var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      staticClass: "rb-header__component",
      class: [
        _vm.classNameIsStatic,
        _vm.classNameCollapsed,
        _vm.classNameBackground,
      ],
    },
    [
      _vm.isSearchPanelOpen && !_vm.isMobile
        ? _c("rb-search-panel", {
            on: { searchClosed: _vm.closeSearchPanel },
            scopedSlots: _vm._u(
              [
                {
                  key: "featured-products",
                  fn: function () {
                    return [_vm._t("search-panel-featured-products")]
                  },
                  proxy: true,
                },
                {
                  key: "popular",
                  fn: function () {
                    return [_vm._t("search-panel-popular")]
                  },
                  proxy: true,
                },
                {
                  key: "links",
                  fn: function () {
                    return [_vm._t("search-panel-links")]
                  },
                  proxy: true,
                },
                {
                  key: "no-results-1",
                  fn: function () {
                    return [_vm._t("search-panel-no-results-1")]
                  },
                  proxy: true,
                },
                {
                  key: "no-results-2",
                  fn: function () {
                    return [_vm._t("search-panel-no-results-2")]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "header",
          staticClass: "rb-header rb-header__container",
          class: {
            "rb-header__container--is-any-panel-open":
              _vm.isAPanelOpen && !_vm.isStaticPosition,
            "--submenu-overlay": _vm.pageIsPlp,
          },
          attrs: { id: "rb-header" },
        },
        [
          _c("rb-header-eyemed-bar", [_vm._t("eyemed-banner-content")], 2),
          _vm._v(" "),
          _vm.isMessageBarVisible
            ? _c("rb-header-message-bar", {
                ref: "messageBar",
                attrs: {
                  "is-omnichannel-open": _vm.isOmnichannelOpen,
                  "is-no-ecommerce": _vm.isNoEcommerce,
                  "is-button-visible": !_vm.isMobile,
                },
                on: {
                  skipToMainContentClicked: function ($event) {
                    return _vm.resetMenuId()
                  },
                  buttonClicked: _vm.toggleOmnichannel,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "content",
                      fn: function () {
                        return [_vm._t("message-bar-content")]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isMobile
            ? [
                _c(
                  "div",
                  { staticClass: "rb-header__navigation" },
                  [
                    _vm.isSearchPanelOpen
                      ? [
                          _c("rb-search-panel", {
                            on: { searchClosed: _vm.closeSearchPanel },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "featured-products",
                                  fn: function () {
                                    return [
                                      _vm._t("search-panel-featured-products"),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "popular",
                                  fn: function () {
                                    return [_vm._t("search-panel-popular")]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "links",
                                  fn: function () {
                                    return [_vm._t("search-panel-links")]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "no-results-1",
                                  fn: function () {
                                    return [_vm._t("search-panel-no-results-1")]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "no-results-2",
                                  fn: function () {
                                    return [_vm._t("search-panel-no-results-2")]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ]
                      : [
                          _c("div", { staticClass: "navigation__logo" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  "data-element-id": "X_X_MainNav_Logo",
                                  href: _vm.homePageUrl,
                                },
                              },
                              [_vm._m(0)]
                            ),
                          ]),
                          _vm._v(" "),
                          !_vm.isInCart
                            ? _c("rb-header-actions", {
                                attrs: {
                                  "is-account-panel-open":
                                    _vm.isAccountPanelOpen,
                                  "is-a-panel-open": _vm.isAPanelOpen,
                                  "is-no-ecommerce": _vm.isNoEcommerce,
                                  "promo-bullet-is-visible":
                                    _vm.promoBulletIsVisible,
                                },
                                on: {
                                  searchClicked: _vm.openSearchPanel,
                                  accountClicked: _vm.toggleAccountPanel,
                                  openClicked: _vm.openNavigationMenuPanel,
                                  closeClicked: _vm.closePanels,
                                  cartClicked: _vm.navigateToCart,
                                },
                              })
                            : _vm._e(),
                        ],
                  ],
                  2
                ),
                _vm._v(" "),
                _vm._t("promo-stripe"),
              ]
            : [
                _c(
                  "div",
                  { staticClass: "rb-header__navigation" },
                  [
                    _c("div", { staticClass: "navigation__logo" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            "data-element-id": "X_X_MainNav_Logo",
                            href: _vm.homePageUrl,
                          },
                        },
                        [_vm._m(1)]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { ref: "mainMenu", staticClass: "navigation__main-menu" },
                      [_vm._t("main-menu")],
                      2
                    ),
                    _vm._v(" "),
                    _c("rb-header-actions", {
                      ref: "desktopActions",
                      attrs: {
                        "is-account-panel-open": _vm.isAccountPanelOpen,
                        "is-a-panel-open": _vm.isAPanelOpen,
                        "is-no-ecommerce": _vm.isNoEcommerce,
                      },
                      on: {
                        searchClicked: _vm.openSearchPanel,
                        accountClicked: _vm.toggleAccountPanel,
                        openClicked: _vm.openNavigationMenuPanel,
                        closeClicked: _vm.closePanels,
                        cartClicked: _vm.navigateToCart,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isMobile
                          ? _vm.isNavigationSubmenuPanelOpen
                          : _vm.currentMenuIdHasValue,
                        expression:
                          "isMobile ? isNavigationSubmenuPanelOpen : currentMenuIdHasValue",
                      },
                      {
                        name: "menu-mouse-leave",
                        rawName: "v-menu-mouse-leave",
                      },
                    ],
                    staticClass: "rb-header__submenu",
                    style: { zIndex: _vm.HEADER_MINIMUM_Z_INDEX + 2 },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "submenu__items-and-editorial",
                        class: {
                          "submenu__items-and-editorial--with-best-sellers-carousel":
                            _vm.isBestSellerCarouselVisible,
                          "submenu__items-and-editorial--with-wall-products":
                            !_vm.isBestSellerCarouselVisible &&
                            _vm.isEditorialWallVisible,
                          "submenu__items-and-editorial--without-editorial":
                            _vm.isEditorialSectionNotPresent,
                        },
                        on: { click: _vm.closeMenuPanel },
                      },
                      [
                        _c(
                          "rb-header-dynamic-menu-renderer",
                          { attrs: { "menu-id": _vm.currentMenuId } },
                          [_vm._t("submenus")],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "rb-header-dynamic-menu-renderer",
                          {
                            attrs: {
                              "menu-id": _vm.currentMenuId,
                              "on-best-seller-carousel-render":
                                _vm.setBestSellerCarouselVisibility,
                              "on-editorial-wall-render":
                                _vm.setEditorialWallVisibility,
                            },
                          },
                          [_vm._t("editorial")],
                          2
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "rb-header-dynamic-menu-renderer",
                      {
                        staticClass: "rb-terms-and-conditions",
                        attrs: { "menu-id": _vm.currentMenuId },
                      },
                      [_vm._t("terms-and-conditions")],
                      2
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.currentMenuIdHasValue ? _vm._t("promo-stripe") : _vm._e(),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _vm.isMobile
        ? [
            _c("rb-header-navigation-menu-panel", {
              attrs: {
                "is-open": _vm.isNavigationMenuPanelOpen,
                "z-index": _vm.HEADER_MINIMUM_Z_INDEX + 2,
                offsets: _vm.offsets,
                "header-is-collapsed": _vm.headerIsCollapsed,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "content",
                    fn: function () {
                      return [_vm._t("main-menu")]
                    },
                    proxy: true,
                  },
                  {
                    key: "omnichannel",
                    fn: function () {
                      return [
                        !_vm.isNoEcommerce
                          ? _c("rb-header-message-bar-button", {
                              attrs: {
                                "is-clicked": _vm.isOmnichannelSubmenuOpen,
                              },
                              on: {
                                buttonClicked: _vm.toggleOmnichannelSubmenu,
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                true
              ),
            }),
            _vm._v(" "),
            _c("rb-header-navigation-submenu-panel", {
              attrs: {
                "is-open": _vm.isNavigationSubmenuPanelOpen,
                "z-index": _vm.HEADER_MINIMUM_Z_INDEX + 3,
                offsets: _vm.offsets,
                "header-is-collapsed": _vm.headerIsCollapsed,
                variant: "mobileSubmenuPanel",
              },
              on: {
                back: _vm.closeSubmenuPanelAndResetMenuId,
                close: _vm.closePanelsAndResetMenuId,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c(
                          "rb-header-dynamic-submenu-title",
                          [_vm._t("main-menu")],
                          2
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "content",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          [
                            _c(
                              "rb-header-dynamic-navigation-submenu-panel",
                              [_vm._t("editorial")],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "rb-header-dynamic-navigation-submenu-panel",
                              [_vm._t("submenus")],
                              2
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "rb-header-dynamic-navigation-submenu-panel",
                          { staticClass: "rb-terms-and-conditions" },
                          [_vm._t("terms-and-conditions")],
                          2
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                true
              ),
            }),
            _vm._v(" "),
            _c("rb-header-navigation-submenu-panel", {
              attrs: {
                "is-open": _vm.isOmnichannelSubmenuOpen,
                "z-index": _vm.HEADER_MINIMUM_Z_INDEX + 4,
                offsets: _vm.offsets,
                "header-is-collapsed": _vm.headerIsCollapsed,
                variant: "omnichannel",
              },
              on: { back: _vm.closeOmnichannelSubmenu, close: _vm.closePanels },
              scopedSlots: _vm._u(
                [
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c("div", { staticClass: "submenu__title" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.translation("header.message_bar_title")
                              ) +
                              "\n        "
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "content",
                    fn: function () {
                      return [_c("rb-header-omnichannel")]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                535663442
              ),
            }),
            _vm._v(" "),
            _c("rb-header-account-side-panel", {
              attrs: {
                "is-open": _vm.isAccountPanelOpen,
                "z-index": _vm.HEADER_MINIMUM_Z_INDEX + 4,
                offsets: _vm.offsets,
                "header-is-collapsed": _vm.headerIsCollapsed,
              },
              on: { panelClosed: _vm.closeAccountPanel },
            }),
          ]
        : [
            _c("rb-header-account-side-panel", {
              attrs: {
                "is-open": _vm.isAccountPanelOpen,
                "z-index": _vm.HEADER_MINIMUM_Z_INDEX + 3,
                offsets: _vm.offsets,
                "header-is-collapsed": _vm.headerIsCollapsed,
                "wcag-hidden-button-is-focusable":
                  _vm.wcagHiddenButtonIsFocusable,
              },
              on: { panelClosed: _vm.closeAccountPanel },
            }),
            _vm._v(" "),
            _c("rb-header-omnichannel-side-panel", {
              attrs: {
                "is-open": _vm.isOmnichannelOpen,
                "z-index": _vm.HEADER_MINIMUM_Z_INDEX + 4,
                offsets: _vm.offsets,
                "header-is-collapsed": _vm.headerIsCollapsed,
                "wcag-hidden-button-is-focusable":
                  _vm.wcagHiddenButtonIsFocusable,
              },
              on: { panelClosed: _vm.closeOmnichannel },
            }),
          ],
      _vm._v(" "),
      _c("div", {
        staticClass: "omnichannel__overlay",
        class: { "omnichannel__overlay--visible": _vm.isOmnichannelOpen },
        style: {
          top: _vm.offsets.messageBar + "px",
          zIndex: _vm.HEADER_MINIMUM_Z_INDEX + 1,
        },
        on: { click: _vm.closeOmnichannel },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "header__overlay",
        class: { "header__overlay--visible": _vm.isOverlayVisible },
        style: {
          top: _vm.offsets.navigation + "px",
          zIndex: _vm.HEADER_MINIMUM_Z_INDEX + 1,
        },
        on: { click: _vm.closePanelsAndResetMenuId },
      }),
      _vm._v(" "),
      _c("rb-monetate"),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        attrs: {
          src: "/rbstatichtml/assets/images/icons/red-logo.svg",
          alt: "Ray Ban Genuine Since 1937",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        attrs: {
          src: "/rbstatichtml/assets/images/icons/red-logo.svg",
          alt: "Ray Ban Genuine Since 1937",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }